<template>
	<div id="modal-inventory-products-adjust-quantity" size="sm">
		<b-modal :id="modalName" hide-footer>
            <template v-slot:modal-title>
                Adjust Quantity
            </template>

            <b-form-group
                id="input-group-quantity"
                label="QTY:"
                label-for="input-quantity"
            >
                <b-form-input
                    id="input-quantity"
                    v-model="quantity"
                    type="text"
                    placeholder=""
                    autocomplete="off"
                >
                </b-form-input>
            </b-form-group>

            <b-button type="submit" variant="success" @click="adjustQuantity">
                <span v-if="submitting">
                    <b-spinner small type="grow"></b-spinner>
                    Updating...
                </span>
                <span v-else>Update</span>
            </b-button>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'id'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-inventory-products-adjust-quantity',
                quantity: null,
                submitting: 0
			}
		},

		methods: {
            adjustQuantity() {
                this.submitting = 1

                let url = 'api/inventory/products/adjustquantity'
                axios.post(url, {
                    rowId: this.id,
                    quantity: this.quantity
                })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'Success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Quantity Adjusted', 'Manual quantity adjusted successfully!')
                        this.$emit('updateRow')
                    } else {
                        this.showAlertBox('error', 'Error Adjusting Quantity', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
            }
		},

		computed: {

		},

		mounted() {

		}
	}
</script>
<style lang="scss">
    #modal-inventory-products-adjust-quantity {
        .modal-dialog {
            width: 250px;
        }
    }
</style>
